<template>
  <q-checkbox
    v-if="isEnabled"
    v-model="model"
    :dense="dense"
    :label="label"
    :left-label="leftLabel"
    :disable="disable"
    :indeterminate="indeterminate"
    :indeterminate-value="indeterminateValue"
    :cy-data="cyData"
    :class="className"
    :style="style"
    :title="title"
    @click="handleClick"
    @update:model-value="handleUpdateModelValue"
  >
    <slot />
  </q-checkbox>
  <CuiCheckbox
    v-else
    v-model="model"
    :checkboxLabel="label"
    :disabled="disable"
    :indeterminate="indeterminate"
    size="medium"
    :class="className"
    :style="style"
    :disabledReason="title"
    @update:modelValue="handleUpdateModelValue"
  >
    <slot />
  </CuiCheckbox>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpCheckbox");

type Props = {
  modelValue?: boolean | null | undefined;
  dense?: boolean;
  label?: string;
  leftLabel?: boolean;
  disable?: boolean;
  indeterminate?: boolean;
  indeterminateValue?: any;
  cyData?: string;
  class?: string;
  style?: string | object;
  title?: string;
};

const props = withDefaults(defineProps<Props>(), {
  dense: false,
  leftLabel: false,
  disable: false,
  indeterminate: false
});

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean | null | undefined): void;
  (e: "click", event: MouseEvent): void;
  (e: "input", value: boolean): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value)
});

const className = computed(() => props.class);

function handleClick(event: MouseEvent) {
  emit("click", event);
}

function handleUpdateModelValue(value: boolean | null | undefined) {
  emit("update:modelValue", value);
  if (typeof value === "boolean") {
    emit("input", value);
  }
}
</script>
